require('expose-loader?exposes=jQuery!jquery');
require('expose-loader?exposes=Floatl!floatl');
require('expose-loader?exposes=micromodal!micromodal');
require('expose-loader?exposes=Cookies!js-cookie');
require('slick-carousel');
require('../../../vendor/silverstripe/admin/client/dist/js/i18n');
